import React from "react";
import { useNavigate } from "react-router-dom";
import useViewportWidth from "../hooks/useViewportWidth";
import beerIcon from "../assets/page_logo.png";
import pouringBeer from "../assets/pouring_beer.png";
import cellPhoneNotification from "../assets/cellphone_notification.png";
import beerIconForBadge from "../assets/badge_beer_icon1.png";
import orangeCircleBg from "../assets/orange_circle_bg.png";
import checkIcon from "../assets/check_icon.png";
import arrowIcon from "../assets/arrow_icon.png";
import usersIcon from "../assets/icon_users.png";
import lightningIcon from "../assets/icon_lightning.png";
import guardIcon from "../assets/icon_guard.png";
import leftBottomOrangeBg from "../assets/left_bottom_orange.png";
import rightTopOrangeBg from "../assets/right_top_orange.png";

function BecomePartner() {
  const navigate = useNavigate();
  // The two hard line breaks in the hero copy below are the desktop design's line endings.
  // A phone re-wraps every fragment, so they stop being line endings and become mid-sentence
  // stubs. They are the only reason this screen needs the width. AC-MOBILE-F17.
  const isMobile = useViewportWidth() < 900;

  return (
    <div style={{ backgroundColor: "rgba(249, 247, 243, 0.8)", width: "100%" }}>
      <div data-testid="partner-top-bar" style={topBarStyle}>
        <div style={isMobile ? logoWrapMobileStyle : logoWrapStyle}>
          <img  onClick={() => navigate("/")}  src={beerIcon} alt="my Hoom logo" style={{ width: "150px" }} />
        </div>
        <div style={topNavStyle}>
          <button
            onClick={() => {
              document.getElementById("benefits-section")?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
            style={navLinkStyle}
          >
            Benefits
          </button>
          <button
            onClick={() => {
              document.getElementById("how-it-works-section")?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
            style={navLinkStyle}
          >
            How It Works
          </button>
          <div style={topActionsStyle}>
            <button onClick={() => navigate("/admin-signup")} style={primaryButtonStyle}>
              Start Earning
            </button>
          </div>
        </div>
      </div>
      <div style={{borderBottom: "1px solid #E0D6C8", height: "1px", width: "100%"}}></div>
      <section style={heroSectionStyle}>
        <img
          src={orangeCircleBg}
          alt="orange circle background"
          style={heroWashStyle}
        />
        <div style={heroLeftStyle}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px", backgroundColor: "rgba(245, 141, 34, 0.1)", padding: "5px 10px", borderRadius: "100px", width: "fit-content" }}>
            <img src={beerIconForBadge} alt="beer icon" style={{ width: "14px", height: "14px", marginLeft: "14px" }} />
            <p style={{ fontSize: "16px", color: "#F58D22", fontWeight: "bold", textTransform: "uppercase", margin: "8px 14px" }}> Partner Program</p>
          </div>
          <h1 style={heroHeadingStyle}>
            Turn <span style={{ color: "#DE810E" }}>digital</span><br />
            gifts into <span style={{ color: "#DE810E" }}>local</span><br />
            pours.
          </h1>
          <p style={heroTextStyle}>
            Let customers buy rounds and pre-purchase your{isMobile ? " " : <br />}
            finest brews for their friends. Increase foot traffic{isMobile ? " " : <br />}
            with zero upfront costs.
          </p>
          <div style={isMobile ? ctaRowMobileStyle : ctaRowStyle}>
            <button
              onClick={() => navigate("/admin-signup")}
              style={isMobile ? ctaButtonMobileStyle : arrowButtonStyle}
            >
              Become a Partner <img src={arrowIcon} alt="arrow icon" style={{ width: "20px", height: "20px" }} />
            </button>
            <div style={isMobile ? assurancesMobileStyle : assurancesStyle}>
              <div style={assuranceStyle}>
                <img src={checkIcon} alt="check icon" style={{ width: "18px", height: "18px" }} />
                <p style={isMobile ? assuranceTextMobileStyle : assuranceTextStyle}>No setup fees</p>
              </div>
              <div style={assuranceStyle}>
                <img src={checkIcon} alt="check icon" style={{ width: "18px", height: "18px" }} />
                <p style={isMobile ? assuranceTextMobileStyle : assuranceTextStyle}>Automatic payouts</p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <img
            src={cellPhoneNotification}
            alt="cellphone notification"
            style={isMobile ? heroImageMobileStyle : heroImageStyle}
          />
        </div>
      </section>

      <section id="benefits-section" style={sectionStyle}>
        <h2 style={sectionTitleStyle}>
          {/* nowrap: the heading wrapped between "my" and "HOOM" on a phone, which reads as
              two words rather than one product name. AC-MOBILE-F15. */}
          Why partners love{" "}
          <span style={{ color: "#DE810E", whiteSpace: "nowrap" }}>my HOOM</span>
        </h2>
        <p style={sectionSubtitleStyle}>
          We built our platform to be entirely frictionless for your staff while<br />driving net-new revenue.
        </p>
        <div style={cardGridStyle}>
          <div style={cardStyle}>
            <img src={usersIcon} alt="users icon" style={{ width: "28px", height: "28px", backgroundColor: "rgba(245, 141, 34, 0.1)", padding: "14px", borderRadius: "14px"  }} />
            <h4 style={cardTitleStyle}>Increased Foot Traffic</h4>
            <p style={cardTextStyle}>
              When a beer is gifted, the recipient has to come into your location to claim it. Most stay for a second (or third) round, bringing friends along with them.
            </p>
          </div>
          <div style={cardStyle}>
            <img src={guardIcon} alt="gurad icon" style={{ width: "28px", height: "28px", backgroundColor: "rgba(245, 141, 34, 0.1)", padding: "14px", borderRadius: "14px"  }} />
            <h4 style={cardTitleStyle}>Zero Hardware</h4>
            <p style={cardTextStyle}>
              No new tablets or POS integrations required. Staff just scan a QR code on the customer's phone to verify the pour.
            </p>
          </div>
          <div style={cardStyle}>
          <img src={lightningIcon} alt="lightning icon" style={{ width: "28px", height: "28px", backgroundColor: "rgba(245, 141, 34, 0.1)", padding: "14px", borderRadius: "14px"  }} />
            <h4 style={cardTitleStyle}>Risk-Free</h4>
            <p style={cardTextStyle}>
              No monthly fees. No setup costs. You only pay a small transaction fee when a beer is successfully claimed at your location.
            </p>
          </div>
        </div>
      </section>

      <section id="how-it-works-section" style={howItWorksSectionStyle}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <h2 style={sectionTitleStyle}>How it works for you</h2>
          <p style={howItWorksSubtitleStyle}>
            From signup to your first payout, the entire process is designed to be
            effortless.
          </p>
          <div style={stepsWrapStyle}>
            {[
              ["01", "Create Profile", "It takes less than 10 minutes to go live on the network."],
              ["02", "Receive Gifts", "Customers buy your beers through the app and gift them to friends via text or social media."],
              ["03", "Verify & Pour", "Recipient shows the bartender their active app screen. Tap the screen to mark as claimed. Pour the beer."],
              ["04", "Get Paid", "Funds for all claimed beers are automatically deposited into your bank account within 30 days."],
            ].map(([number, title, text], index) => (
              <div key={number} style={stepCardStyle}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
                  <div style={index === 0 ? stepBadgeActiveStyle : stepBadgeStyle}>{number}</div>
                  {index !== 3 && <div style={stepsConnectorStyle} />}
                </div>
                <h4 style={stepTitleStyle}>{title}</h4>
                <p style={stepTextStyle}>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={bottomCtaStyle}>
        <img src={leftBottomOrangeBg} alt="left bottom orange background" style={{ position: "absolute", width:"478px", bottom: "0", left: "0"}} />
        <img src={rightTopOrangeBg} alt="right top orange background" style={{ position: "absolute", top: "0px", width:"478px", right: "-288px"}} />
        <h2 style={ctaHeadingStyle}>
          Ready to pour more <br />
          <span style={{ color: "#F58D22" }}>pints together?</span>
        </h2>
        <p style={ctaTextStyle}>
          Join local establishments turning social moments into pre-paid pints. Sign up today — it's 100% free to start.
        </p>
        <div style={{ display: "flex", justifyContent: "center", marginTop: "52px" }}>
          <button onClick={() => navigate("/admin-signup")} style={arrowButtonStyle}>
            Create Your Partner Profile <img src={arrowIcon} alt="arrow icon" style={{ width: "20px", height: "20px" }} />
          </button>
        </div>
        <p style={ctaTextStyle}>Have questions? <span style={{ color: "#2C241B", textDecoration: "underline", cursor: "pointer" }}>Talk to our partnership team</span></p>
      </section>

      <section style={partnerFooterSectionStyle}>
        <div style={isMobile ? partnerFooterInnerMobileStyle : partnerFooterInnerStyle}>
          <img
            src={beerIcon}
            alt="my Hoom logo"
            style={{ width: "120px", cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
          <div style={partnerFooterLinksStyle}>
            <button style={partnerFooterLinkStyle} onClick={() => navigate("/")}>
              Platform
            </button>
            <button style={partnerFooterLinkStyle} onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
              Partners
            </button>
            <button style={partnerFooterLinkStyle} onClick={() => navigate("/contact")}>
              Support
            </button>
            <button
              style={partnerFooterLinkStyle}
              onClick={() => navigate("/terms-of-use")}
            >
              Terms of Service
            </button>
            <button style={partnerFooterLinkStyle} onClick={() => navigate("/privacy")}>
              Privacy
            </button>
          </div>
          <p style={partnerFooterCopyrightStyle}>© {new Date().getFullYear()} my HOOM.LLC</p>
        </div>
      </section>
    </div>
  );
}

const topBarStyle = {
  maxWidth: "1100px",
  margin: "0 auto",
  padding: "0 20px",
  display: "flex",
  // The 150px logo plus three nav controls do not fit a phone on one line.
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "clamp(12px, 3vw, 24px)",
  minHeight: "86px",
};

const logoWrapStyle = {
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
};

// The bar is a space-between row, so once the nav wraps to its own line the logo is left
// alone on the first row and stays pinned to its left edge. Taking the whole row and
// centring in it is what makes it read as a header rather than a stranded image.
// AC-MOBILE-F21.
const logoWrapMobileStyle = {
  ...logoWrapStyle,
  flex: "1 1 100%",
  justifyContent: "center",
};

const topActionsStyle = {
  display: "flex",
  alignItems: "center",
};

const topNavStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "clamp(12px, 3vw, 26px)",
  flex: "1 1 auto",
};

const navLinkStyle = {
  border: "none",
  background: "transparent",
  color: "#555",
  fontSize: "14px",
  fontWeight: "bold",
  cursor: "pointer",
  padding: 0,
};

const sectionStyle = {
  maxWidth: "1100px",
  margin: "0 auto",
  padding: "64px 20px",
  textAlign: "center",
};

const howItWorksSectionStyle = {
  backgroundColor: "#FFFFFF",
  margin: "0 auto",
  padding: "76px 20px 64px",
  textAlign: "center",
};

const heroSectionStyle = {
  // Deliberately NOT positioned. The decorative wash above is position:absolute with no
  // offsets of its own, so with no positioned ancestor it anchors to the initial containing
  // block and bleeds from the page's top-left corner — which is the design: a soft orange
  // wash across the left of the whole page, not a wash that starts wherever this centred
  // 1100px column happens to start. Making this section relative moved it inward by half
  // the gutter (~390px at 1880px wide). The 390px overflow that change was fixing is
  // handled at the image instead — see heroWashStyle. AC-MOBILE-F1.
  maxWidth: "1100px",
  margin: "0 auto",
  padding: "clamp(24px, 6vw, 36px) 20px clamp(32px, 8vw, 56px)",
  display: "grid",
  gap: "28px",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  alignItems: "center",
};

const heroLeftStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  textAlign: "left",
  gap: "16px",
};

const heroHeadingStyle = {
  margin: 0,
  color: "#2E2E2E",
  // The floor was 38px, which is a desktop display size on a 350px content box — it left
  // "gifts into local" filling the line edge to edge with nothing around it. AC-MOBILE-F17.
  fontSize: "clamp(32px, 8.5vw, 72px)",
  lineHeight: 1.1,
  letterSpacing: "-1px",
};

const heroTextStyle = {
  margin: 0,
  color: "#6B5C4D",
  maxWidth: "520px",
  lineHeight: 1.6,
  // 20px from ~455px up, which keeps the designed desktop measure. AC-MOBILE-F17.
  fontSize: "clamp(16px, 4.4vw, 20px)",
  fontWeight: "507",
};

const heroRightStyle = {
  display: "flex",
  justifyContent: "center",
};

// Anchored to the initial containing block (nothing above it is positioned), so left: 0 is the
// page's left edge at every width. maxWidth caps it against the viewport rather than a column,
// which is what keeps a 543px-wide image off a 390px screen: it scales to 390 and the page
// stays put. Height follows, so the wash keeps its shape instead of being squashed.
// AC-MOBILE-F1.
const heroWashStyle = {
  position: "absolute",
  top: "0",
  left: "0",
  maxWidth: "100%",
  height: "auto",
  pointerEvents: "none",
};

// The mockup is a 920x920 square sized by its HEIGHT, deliberately wider than the 516px grid
// column it sits in — it is meant to spill toward the page edge, and constraining it to the
// column shrank it by a third. 46vw is what keeps that spill inside the viewport: at 1440px it
// draws 662px and stops 44px short of the edge, where a flat 740px ran 34px past it.
const heroImageStyle = {
  width: "auto",
  height: "min(740px, 46vw)",
  // Opts out of the global `img { max-width: 100% }` in index.css, which is what actually
  // shrank this mockup: that rule reads 100% as the 536px grid column, so a 920x920 square
  // asked to be 740 tall came out 536 wide and stretched. Height alone does not escape it —
  // max-width clamps the width and the ratio goes with it.
  maxWidth: "none",
};

// Below 900px the grid has already stacked and there is no column to spill out of — the phone
// is simply the width of the screen, so the mockup is sized by width like any other block.
const heroImageMobileStyle = {
  width: "100%",
  maxWidth: "740px",
  height: "auto",
};

const sectionTitleStyle = {
  margin: 0,
  color: "#2E2E2E",
  fontSize: "clamp(28px, 6vw, 48px)",
  lineHeight: 1.1,
};

const sectionSubtitleStyle = {
  margin: "12px auto 0",
  color: "#666",
  maxWidth: "620px",
};

const howItWorksSubtitleStyle = {
  margin: "14px auto 0",
  color: "#6E6254",
  maxWidth: "630px",
  fontSize: "20px",
  lineHeight: 1.35,
  fontWeight: 600,
};

const cardGridStyle = {
  marginTop: "28px",
  display: "grid",
  gap: "16px",
  // auto-fit rather than a fixed 3, and no gridTemplateAreas: a template area list pins the
  // column count and would override auto-fit entirely. At >=1028px of content this still
  // resolves to the three columns the design has. AC-MOBILE-F1.
  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
};
const cardStyle = {
  backgroundColor: "#FFF",
  border: "1px solid #ECECEC",
  borderRadius: "14px",
  padding: "20px",
  textAlign: "left",
};



const cardTitleStyle = {
  margin: "24px 0 16px",
  fontSize: "24px",
  fontWeight: "black",
  color: "#2C241B",
};

const cardTextStyle = {
  margin: 0,
  color: "#666",
  lineHeight: 1.55,
};

const stepsWrapStyle = {
  marginTop: "54px",
  position: "relative",
  display: "grid",
  gap: "22px",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  alignItems: "start",
};

const stepCardStyle = {
  position: "relative",
  zIndex: 1,
  backgroundColor: "transparent",
  border: "none",
  padding: 0,
  textAlign: "left",
};

const stepBadgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#FFFFFF",
  color: "#DE810E",
  borderRadius: "14px",
  border: "2px solid #EEE3D8",
  boxShadow: "0 2px 7px rgba(0, 0, 0, 0.08)",
  fontWeight: "bold",
  padding: "18px 22px",
  fontSize: "20px",
  lineHeight: 1.2,
};

const stepTitleStyle = {
  margin: "24px 0 14px",
  color: "#2E2E2E",
  fontSize: "24px",
  lineHeight: 1.15,
};

const stepTextStyle = {
  margin: 0,
  color: "#54493F",
  lineHeight: 1.4,
  fontSize: "16px",
};

const stepsConnectorStyle = {
  height: "2px",
  width: "100%",
  background:
    "linear-gradient(90deg, rgba(232, 223, 212, 0) 0%, rgba(232, 223, 212, 1) 12%, rgba(232, 223, 212, 1) 88%, rgba(232, 223, 212, 0) 100%)",
  zIndex: 0,
};

const stepBadgeActiveStyle = {
  ...stepBadgeStyle,
  backgroundColor: "#DE810E",
  color: "#FFFFFF",
};

const bottomCtaStyle = {
  position: "relative",
  // The two decorative images below are absolutely positioned and one sits at
  // right: -288px. It is meant to bleed off the edge of this section; with no overflow rule
  // it bled off the edge of the DOCUMENT, which was this page's horizontal scroll on every
  // width narrow enough to notice. AC-MOBILE-F1.
  overflow: "hidden",
  backgroundColor: "#F9F7F3",
  padding: "clamp(48px, 10vw, 72px) 20px",
  textAlign: "center",
};

const ctaHeadingStyle = {
  margin: 0,
  fontSize: "clamp(30px, 7vw, 52px)",
  lineHeight: 1.05,
  color: "#2E2E2E",
};

const ctaTextStyle = {
  margin: "14px auto 24px",
  fontSize: "14px",
  fontWeight: "bold",
  color: "#666",
};

// The hero CTA row, unchanged: one unwrappable line of button + two assurances, exactly as it
// draws today at every width from 900px up. The hero column is inside a maxWidth: 1100px
// section, so "desktop" here is one fixed 536px column and not a range.
const ctaRowStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

// And the phone version. Unwrappable, that row gave the button whatever the assurances did not
// need and stacked "Become a Partner" three words deep, with both assurances broken in half
// beside it. Wrapping is the whole fix. AC-MOBILE-F16.
const ctaRowMobileStyle = {
  ...ctaRowStyle,
  flexWrap: "wrap",
  gap: "16px",
};

// display: contents on a desktop — the wrapper exists only to make the two assurances wrap as
// ONE group on a phone, and contents takes its box out of the layout so the row above still
// sees three children and lays them out exactly as it did before this wrapper existed.
// Wrapping the assurances one at a time is not the same thing: it leaves the button sharing a
// row with the first tick and the second stranded beneath it, which is the accident F6
// describes for the home nav.
const assurancesStyle = {
  display: "contents",
};

const assurancesMobileStyle = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "8px 20px",
};

const assuranceStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
};

const assuranceTextStyle = {
  fontSize: "14px",
  fontWeight: "bold",
  color: "#6B5C4D",
};

const assuranceTextMobileStyle = {
  ...assuranceTextStyle,
  // The <p> carries the UA's block margins, which inside a flex row is most of why the spacing
  // around this row read as uneven on a phone.
  margin: 0,
  whiteSpace: "nowrap",
};

const arrowButtonStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  fontSize: "clamp(16px, 4.2vw, 18px)",
  lineHeight: 1,
  fontWeight: 700,
  backgroundColor: "#F58D22",
  color: "white",
  border: "none",
  borderRadius: "999px",
  padding: "clamp(14px, 3.6vw, 17px) clamp(22px, 6vw, 32px)",
  cursor: "pointer",
  boxShadow: "0 14px 28px rgba(245, 141, 34, 0.35)",
};

// Phone only, and only for the hero CTA: the label holds one line and the row above it wraps
// instead of the button shrinking. On a desktop the button still shrinks to share its row, which
// is what it has always done. AC-MOBILE-F16.
const ctaButtonMobileStyle = {
  ...arrowButtonStyle,
  whiteSpace: "nowrap",
  flexShrink: 0,
};

const primaryButtonStyle = {
  backgroundColor: "#DE810E",
  color: "white",
  border: "none",
  borderRadius: "28px",
  padding: "12px 24px",
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: "bold",
  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
};

const partnerFooterSectionStyle = {
  backgroundColor: "#FFFFFF",
  borderTop: "1px solid #E6DED3",
};

// "auto 1fr auto" is the desktop footer: the logo and the copyright take the width they need
// and the links get everything left over, which is the ~700px the five of them want on one
// line. Replacing it with auto-fit minmax(200px, 1fr) — to stop the three tracks being forced
// side by side on a phone — gave every track an equal 337px inside the 1100px container, and
// the links wrapped onto two rows on a desktop that had room to spare. The phone case is
// handled by the width the rest of this file already branches on. AC-MOBILE-D3.
const partnerFooterInnerStyle = {
  maxWidth: "1100px",
  margin: "0 auto",
  padding: "22px 20px",
  display: "grid",
  gridTemplateColumns: "auto 1fr auto",
  alignItems: "center",
  gap: "24px",
};

// Below 900px the three tracks become three rows. An explicit single column rather than
// auto-fit: auto-fit collapses only once the tracks no longer fit, which is a different
// question from the one being asked here. AC-MOBILE-F1.
const partnerFooterInnerMobileStyle = {
  ...partnerFooterInnerStyle,
  gridTemplateColumns: "1fr",
  justifyItems: "center",
};

const partnerFooterLinksStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "30px",
  flexWrap: "wrap",
};

const partnerFooterLinkStyle = {
  border: "none",
  background: "transparent",
  color: "#4F473F",
  cursor: "pointer",
  fontSize: "14px",
  fontWeight: 600,
  padding: 0,
};

const partnerFooterCopyrightStyle = {
  margin: 0,
  color: "#3A342E",
  fontSize: "14px",
  fontWeight: 700,
};

export default BecomePartner;
